import { createFileRoute, redirect } from '@tanstack/react-router';
import { legacyOutreachTarget } from '@/pages/campaigns/legacy-redirect';

// Campaigns moved out of Setup to /campaigns (ADR-318, P10); old links keep working.
export const Route = createFileRoute('/_authenticated/setup/outreach')({
  beforeLoad: ({ search }) => {
    throw redirect({ ...legacyOutreachTarget(search as Record<string, unknown>), replace: true });
  },
});
